import { onResetPassword, resetAuthState } from './ResetPassword.commands';

import { getId } from '/b2b/authentication/state/user/AuthUser.selectors';
import { getUrlParams } from '/b2b/common/state/selectors';
import { isLoading } from '/b2b/authentication/state/Auth.selectors';

export const mapStateToProps = state => {
    return {
        code: getUrlParams(state, 'code') || '',
        isLoading: isLoading(state),
        username: getUrlParams(state, 'email') || getId(state),
    };
};

export const mapDispatchToProps = { onResetPassword, resetAuthState };
